export class GenericError extends Error {
  status: number;

  constructor(status: number) {
    super('GenericError');
    this.name = 'GenericError';
    this.status = status;
  }
}
